import { KeyValueDiffers, ViewContainerRef } from '@angular/core';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { DeviceService } from "./device.service";
import { Router } from "@angular/router";
var DeviceComponent = (function () {
    function DeviceComponent(deviceService, differs, toastr, vcr, router) {
        this.deviceService = deviceService;
        this.differs = differs;
        this.toastr = toastr;
        this.vcr = vcr;
        this.router = router;
        this.toastr.setRootViewContainerRef(vcr);
        this.differ = this.differs.find({}).create();
    }
    DeviceComponent.prototype.ngOnInit = function () {
        this.title = "Device";
        this.filterParams = {
            size: 10,
            page: 0
        };
    };
    DeviceComponent.prototype.ngDoCheck = function () {
        var change = this.differ.diff(this.filterParams);
        if (change) {
            if (this.filterParams.page < 0) {
                this.filterParams.page = 0;
                return;
            }
            else if (this.filterParams.page > this.totalPage - 1) {
                this.filterParams.page = this.totalPage - 1;
                return;
            }
            this.getDeviceList();
        }
    };
    DeviceComponent.prototype.getDeviceList = function () {
        var _this = this;
        this.isLoading = true;
        this.deviceService.getDeviceList(this.filterParams)
            .then(function (res) {
            if (res.status === 1) {
                _this.deviceList = res.data.dataList;
                _this.totalElements = res.data.totalElements;
                _this.initPaginate();
                _this.isLoading = false;
            }
            else {
                _this.toastr.error(res.message, 'Error!');
                if (res.errorCode === 3000) {
                    localStorage.setItem("alert", JSON.stringify(res.message));
                    _this.router.navigate(['login']);
                }
            }
        })
            .catch(function (err) { return console.log(err); });
    };
    //init paging 
    DeviceComponent.prototype.initPaginate = function () {
        this.totalPage = Math.ceil(this.totalElements / this.filterParams.size);
        var arrPagingNumber = [];
        for (var i = 0; i < this.totalPage; i++) {
            arrPagingNumber.push(i);
        }
        return arrPagingNumber;
    };
    DeviceComponent.prototype.showBoard = function (device) {
        this.deviceInfo = device;
        $('#myModal').modal('show');
    };
    return DeviceComponent;
}());
export { DeviceComponent };



// WEBPACK FOOTER //
// /build/client-cms/src/app/device/device.component.ts.pre-build-optimizer.js